@let unreadCount = unreadCount$ | async;
@let badgeValue = unreadCount ? unreadCount : undefined;

<button mat-icon-button ubbFixedOverlay
        [overlayContent]="notificationsOverlay"
        [overlayPosition]="overlayPosition"
        [hasBackdrop]="true"
        [matBadge]="badgeValue"
>
    <mat-icon>notifications</mat-icon>
</button>

<ng-template #notificationsOverlay>
    <mat-card>
        <mat-card-header>
            {{ "shared.notifications.title" | ubbTranslate | async }}
        </mat-card-header>
        <mat-card-content>
            @let notifications = notifications$ | async;

            @if (notifications?.length === 0) {
                <div>
                    {{ "shared.notifications.empty-list" | ubbTranslate | async }}
                </div>
            }

            @for (notification of notifications; track notification.id) {
                <div class="alert-menu-item"
                     [class.critical]="isSevere(notification)"
                     [class.unread]="notification.acknowledgedAt == null"
                     role="button"
                     tabindex="0"
                     (click)="acknowledge(notification)"
                     (keyup.enter)="acknowledge(notification)"
                >
                    <div class="alert-menu-header">
                        <mat-icon>{{ isSevere(notification) ? "warning" : "info" }}</mat-icon>
                        <span class="alert-title">
                            {{ ("shared.notifications.severity." + notification.maxSeverity) | ubbTranslate | async }}:
                            @for (count of countsByType(notification); track count[0]; let last = $last) {
                                {{ ("shared.notifications.count." + count[0]) | ubbTranslate: { count: count[1] + "" } | async }}{{ last ? "" : ", " }}
                            }
                        </span>
                    </div>
                    @for (item of shownItems(notification); track $index) {
                        <span>
                            {{ ("shared.notifications.type." + item.notificationType) | ubbTranslate | async }}
                            {{ sourceName(item) }}
                            <span class="timestamp">{{ item.occurredAt | dateModel: "yyyy/MM/dd HH:mm" }}</span>
                        </span>
                    }
                    @if (notification.itemCount > maxItemsShown) {
                        <span class="timestamp">
                            {{ "shared.notifications.more" | ubbTranslate: { count: (notification.itemCount - maxItemsShown) + "" } | async }}
                        </span>
                    }
                </div>
            }

        </mat-card-content>
        <mat-card-footer>
            @if (unreadCount) {
                <button mat-button (click)="acknowledgeAll()">
                    {{ "shared.notifications.acknowledge-all" | ubbTranslate | async }}
                </button>
            }
            <button mat-button [routerLink]="['/', 'workspace', 'alerts']">
                {{ "shared.alerts.show-all" | ubbTranslate | async }}
            </button>
            <button mat-button [routerLink]="['/', 'workspace', 'account']" [queryParams]="{ tab: 'notifications' }">
                {{ "shared.notifications.manage-subscriptions" | ubbTranslate | async }}
            </button>
        </mat-card-footer>
    </mat-card>

</ng-template>
